import { useQueryClient } from "@tanstack/react-query";
import i18next from "i18next";
import { useState } from "react";

import { useToast } from "../../../../../hooks/useToast";
import { measurementsService } from "../../../../../services/measurementsService";
import { mixpanelActions } from "../../../../../utils/mixpanel";

export const useArchiveMeasurement = () => {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  const [isRefetching, setIsRefetching] = useState(false);

  const archiveMeasurement = async (
    measurementId: number,
    archive: boolean,
    measurementType: string,
    patientId: string,
    title?: string
  ) => {
    mixpanelActions.track("User Action: Archive value", {
      Event: title,
    });

    setIsRefetching(true);
    const result = await measurementsService.archivePatientMeasurement(
      patientId,
      measurementId,
      archive
    );

    if (result.status >= 200 && result.status < 300) {
      showToast(
        i18next.t(
          archive
            ? "patientPage_measurementModal_table_archived"
            : "patientPage_measurementModal_table_unarchived"
        ),
        "success"
      );

      await queryClient.refetchQueries({
        queryKey: [`${measurementType}-${patientId}-true`],
      });
      setIsRefetching(false);
    } else {
      showToast(
        i18next.t(
          archive
            ? "patientPage_measurementModal_table_archiveFailed"
            : "patientPage_measurementModal_table_unarchiveFailed"
        ),
        "error"
      );
      setIsRefetching(false);
    }
  };

  return { archiveMeasurement, isRefetching };
};
